import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { PlaylistsSharingPremiumPricingElementSubscription } from './options/PlaylistsSharingPremiumPricingElementSubscription';
import { PaddleProductId } from '../../../../paddle';
import { usePaddlePrices } from '../../../../redux/paddle/hooks';
import { BigCTA } from '../../smartLinks/BigCTA';
import { SignUpButton } from '../../components/SignUpButton';

export const PlaylistsSharingPremiumPricing: React.FC = () => {
  const paddlePricing = usePaddlePrices();

  const router = useRouter();
  const intl = useIntl();
  return (
    <div className="premium-pricing" id="pricing">
      <Container className="pt-5 pb-3">
        <Row>
          <Col className="text-center">
            <h2 className="main-header text-center  pt-5 pb-3">
              <FormattedMessage id="sml.web.playlists-sharing.pricing.title" defaultMessage="Pricing" />
            </h2>
          </Col>
        </Row>
        <Row className="text-center justify-content-center mb-5 pb-5">
          <Col xs={12} md={8} lg={6}>
            <h4 className="pt-3 pb-3 fw-bold">
              {intl.formatMessage({
                id: 'sml.web.premium.14-day-trial.title',
                defaultMessage: 'Free 14 day Artist Plan Trial for all new accounts!'
              })}
            </h4>
            <p>
              {intl.formatMessage({
                id: 'sml.web.premium.14-day-trial.desc',
                defaultMessage:
                  'Try out Music24 for free. Check out all the features of Artist plan, and upgrade when needed.'
              })}
            </p>
            <SignUpButton
              source="pricing"
              url={router.asPath}
              size="lg"
              block
              color="secondary"
              className="btn-shadow-secondary"
            >
              {intl.formatMessage({
                id: 'sml.web.premium.get-started',
                defaultMessage: 'Try for FREE!'
              })}
            </SignUpButton>
          </Col>
        </Row>
        <Row className="mt-5" id="pricing">
          <Col xs={12} md={4}>
            <PlaylistsSharingPremiumPricingElementSubscription
              paddlePricing={paddlePricing}
              productId={PaddleProductId.SmartLinksRookie}
            />
          </Col>
          <Col xs={12} md={4}>
            <PlaylistsSharingPremiumPricingElementSubscription
              paddlePricing={paddlePricing}
              productId={PaddleProductId.SmartLinksInfluencer}
              isPromoted
            />
          </Col>
          <Col xs={12} md={4}>
            <PlaylistsSharingPremiumPricingElementSubscription
              paddlePricing={paddlePricing}
              productId={PaddleProductId.SmartLinksArtist}
            />
          </Col>
        </Row>
      </Container>
      <div className="bg-primary-dark">
        <BigCTA roundedTop source="Pricing Bottom" />
      </div>
    </div>
  );
};
